export default "__VITE_ASSET__CHTGf0R5__"